/* eslint-disable max-len */
import * as React from 'react';
import PT from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import { dataLayerEvents } from 'common/utils';

import planeIcon from 'assets/client/imgs/icon-plane.png';
import { PODCAST_ROOT_ROUTE, ROOT_ROUTE } from 'client/constants';

import { connect } from 'react-redux';
import * as css from './Header.scss';

class Menu extends React.PureComponent {
	static propTypes = {
		className: PT.string,
		items: PT.oneOfType([PT.shape({}), PT.arrayOf(PT.shape({}))]).isRequired,
		onClose: PT.func.isRequired,
		isOnPodcast: PT.bool,
		isExact: PT.bool,
		path: PT.string,
	};

	static defaultProps = {
		className: '',
		isOnPodcast: false,
		isExact: false,
		path: '',
	};

	onNavLinkClick = e => {
		dataLayerEvents.onNavItemClick(e.currentTarget.dataset.title);
		this.props.onClose();
	};

	render() {
		const { className, items, onClose, isOnPodcast, path, isExact } = this.props;
		const { mainTitle } = _.get(this.props, 'settings.general', '');
		return (
			<div className={classNames(css.menuWrap, className)}>
				<div className={css.menu}>
					<div className={css.list}>
						<NavLink
							to={
								isOnPodcast
									? { pathname: `${ROOT_ROUTE}`, state: { from: 'inAnimFreeze' } }
									: `${ROOT_ROUTE}`
							}
							activeClassName={path === ROOT_ROUTE && isExact ? css.isActive : ''}
							data-title={mainTitle}
							className={css.menuItem}
							onClick={onClose}
						>
							{mainTitle}
							<i style={{ backgroundImage: `url(${planeIcon})` }} className={css.iconPlane} />
						</NavLink>
						{_.map(_.orderBy(items, ['order'], ['asc']), (i, key) => (
							<NavLink
								to={
									isOnPodcast
										? `${PODCAST_ROOT_ROUTE}/${i.id}`
										: { pathname: `${PODCAST_ROOT_ROUTE}/${i.id}`, state: { from: 'inAnimFreeze' } }
								}
								key={`menu-item-${key}`}
								className={css.menuItem}
								activeClassName={css.isActive}
								data-title={i.name}
								onClick={this.onNavLinkClick}
							>
								{i.name}
								<i style={{ backgroundImage: `url(${planeIcon})` }} className={css.iconPlane} />
							</NavLink>
						))}
					</div>
					<i className={css.closeBtn} onClick={onClose} />
				</div>
			</div>
		);
	}
}
const mapState = state => ({
	settings: _.get(state, 'settings', {}),
});

const mapDispatch = {};
export default connect(
	mapState,
	mapDispatch
)(Menu);
